export var StatusValues = [
    'requested',
    'shipped',
    'delivered',
    'canceled',
];
export var DeliveryTimingValues = [
    'as_soon_as_possible',
    'specify_date',
];
